import React from 'react';
import { AlertTriangle } from 'lucide-react';

const ConfirmationModal = ({ isOpen, onClose, onConfirm, t }) => {
  if (!isOpen) return null;

  return (
    <div style={styles.overlay} onClick={onClose}>
      <div style={styles.modal} onClick={e => e.stopPropagation()}>
        <div style={styles.header}>
          <div style={styles.iconWrapper}>
            <AlertTriangle color="#f8bb86" size={32} />
          </div>
          <h2 style={styles.title}>{t('optin.modal.title')}</h2>
        </div>
        <div style={styles.content}>
        <p>{t('optin.modal.description')}</p>
         <ul style={styles.list}>
            <li dangerouslySetInnerHTML={{ __html: t('optin.modal.list.scans') }} />
            <li dangerouslySetInnerHTML={{ __html: t('optin.modal.list.sentiment') }} />
            <li dangerouslySetInnerHTML={{ __html: t('optin.modal.list.login') }} />
            <li dangerouslySetInnerHTML={{ __html: t('optin.modal.list.marketing') }} />
        </ul>
        </div>
        <div style={styles.footer}>
          <button
            style={{ ...styles.button, ...styles.secondaryButton }}
            onClick={onConfirm}
          >
            {t('optin.modal.confirm')}
          </button>
          <button
            style={{ ...styles.button, ...styles.primaryButton }}
            onClick={onClose}
          >
            {t('optin.modal.keep')}
          </button>
        </div>
      </div>
    </div>
  );
};

const styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000,
  },
  modal: {
    backgroundColor: 'var(--surface)',
    borderRadius: '12px',
    padding: '2rem',
    width: '90%',
    maxWidth: '650px',
    boxShadow: 'var(--shadow-lg)',
    display: 'flex',
    flexDirection: 'column',
    gap: '1.5rem',
  },
  header: {
    textAlign: 'center',
  },
  iconWrapper: {
    width: '60px',
    height: '60px',
    borderRadius: '50%',
    backgroundColor: '#fef6e6',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '0 auto 1rem',
  },
  title: {
    fontSize: '1.5rem',
    fontWeight: 600,
    color: 'var(--text-primary)',
    margin: 0,
  },
  content: {
    fontSize: '1rem',
    color: 'var(--text-secondary)',
    lineHeight: 1.6,
  },
  list: {
    paddingLeft: '20px',
    marginTop: '1rem',
    display: 'flex',
    flexDirection: 'column',
    gap: '0.75rem',
  },
  footer: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '1rem',
    marginTop: '1rem',
  },
  button: {
    padding: '0.75rem 1.5rem',
    border: 'none',
    borderRadius: '8px',
    fontSize: '1rem',
    fontWeight: 500,
    cursor: 'pointer',
    transition: 'all 0.2s ease',
  },
  primaryButton: {
    backgroundColor: 'var(--primary)',
    color: 'white',
  },
  secondaryButton: {
    backgroundColor: 'var(--disabled)',
    color: 'var(--text-secondary)',
  },
};

export default ConfirmationModal;
